
import { Model } from './_model';
import Participant from './issueParticipant';

export default class SecurityInfo extends Model {
  get defaults() {
    return {
      id: '',
      index: '',
      longName: '',
      prefShortName: '',
      countryOfIssue: '',
      currency: '',
      listingDate: '',
      maturityDate: '',
      amount: '',
      amountOutstanding: '',
      tenor: '',
      issuePrice: '',
      redemptionPrice: '',
      redemptionDetail: [{
        optional_redemption_date: '',
        optional_redemption_price: ''
      }],
      // Additional Fields
      couponType: '',
      couponDiscountRate: '',
      couponFixedInterestRate: '',
      couponFixedRateSettingDate: '',
      couponFixedRefRateUsed: '',
      couponFixedSpreadOverRefRate: '',
      couponFloatingRateBasis: '',
      couponSteppedProvisionDesc: '',
      couponFrequency: '',
      couponPaymentDate: '',
      couponFirstPaymentDate: '',
      couponRecordDate: '2 Business Days',
      couponClosedPeriod: 'Exclusive of Payment Date',
      amountHistory: [],
      denomination: {
        primary: {
          minimum: '',
          increments: ''
        },
        secondary: {
          minimum: '',
          increments: ''
        }
      },
      isDeletable: true,
      save: false
    }
  }
}

